import { Controller } from 'stimulus';
import flatpickr from 'flatpickr';

export default class extends Controller {
	static targets = ["startTime"]

	connect() {
		flatpickr('#startTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		});

		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		});
	}

	selectStartTime() {
		const date = new Date(this.startTimeTarget.value);
		const hours = 22;
		const twentyFourHoursLater = new Date(date.getTime() + (hours * 60 * 60 * 1000));
		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: date,
			maxDate: twentyFourHoursLater,
			dateFormat: 'Y-m-d H:i',
		});
	}

	reset() {
		flatpickr('#startTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		}).clear();

		flatpickr('#endTimeField', {
			altInput: true,
			enableTime: true,
			minDate: 'today',
			dateFormat: 'Y-m-d H:i',
		}).clear();
	}
}
